import React, {
  FC, useEffect, useState,
} from 'react';
import {
  BackgroundImage,
  Button,
} from './Styles';
import Header from '../../../../../Common/Header';
import { Box, Driver } from '../../../../../../../lib/types';
import { updateFoodifoxData } from '../../../../../../../lib/axios/FoodifoxDataAPI';
import ProblemReportModal from '../../../../../Common/ProblemReportModal';
import NoFreeBoxModal from '../../../../../Common/NoFreeBoxModal';
import ReopenButton from '../../../../../Common/ReopenButton';
import OpenedBox from '../../../../../Common/OpenedBox/Driver';
import SquadSemiBoldText from '../../../../../../../components/Text/SquadSemiBoldText';
import PingFangMediumText from '../../../../../../../components/Text/PingFangMediumText';
import DividerLine from '../../../../../../../components/DividerLine';
import RowBetween from '../../../../../../../components/Layout/RowBetween';
import SquadRegularText from '../../../../../../../components/Text/SquadRegularText';
import PingFangRegularText from '../../../../../../../components/Text/PingFangRegularText';

const ReopenBoxSuccess: FC<Props> = ({
  cabId32Str,
  isEnglish,
  setIsEnglish,
  setShowLoading,
  driverId,
  openedBoxes,
  onClose,
}) => {
  const [saveReasonLazy, { loading: saveReasonLoading }] = updateFoodifoxData<{ openBoxes: Box[] }>('/foxH5RentLog/saveCannotUseCabReason');

  const [showNoFreeBoxModal, setShowNoFreeBoxModal] = useState<boolean>();
  const [showProblemModal, setShowProblemModal] = useState<boolean>(false);
  const [curOpenedBoxes, setCurOpenedBoxes] = useState<Box[]>(openedBoxes);

  useEffect(() => {
    setShowLoading(saveReasonLoading);

    return () => {
      setShowLoading(false);
    };
  }, [saveReasonLoading]);

  /**
   * 重新开柜门
   */
  const reopenBox = () => {
    onClose();
  };

  return (
    <BackgroundImage>
      {
        showProblemModal && (
          <ProblemReportModal
            onClose={() => setShowProblemModal(false)}
            onConfirm={(reason) => {
              setShowProblemModal(false);
              saveReasonLazy({
                param: {
                  cabId: cabId32Str,
                  boxNumbers: JSON.stringify(curOpenedBoxes.map((box) => box.boxNumber)),
                  reportUser: 'Driver',
                  driverId,
                  reason,
                },
                onError() {
                  setShowNoFreeBoxModal(true);
                },
                onCompleted(data) {
                  setCurOpenedBoxes(data.openBoxes);
                },
              });
            }}
            isEnglish={isEnglish}
            optionKeys={['Dirty', 'Door is not working', 'Other']}
          />
        )
      }
      {
        showNoFreeBoxModal && (
          <NoFreeBoxModal onClose={() => setShowNoFreeBoxModal(false)} isEnglish={isEnglish} />
        )
      }
      {/* 头部 */}
      <Header
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        style={{ marginTop: '50px' }}
        setTargetPage={() => onClose()}
        showSupport={false}
        showHome={true}
        supportIsOnlyCall={true}
        cabId32Str={cabId32Str}
      />

      {
        isEnglish ? (
          <SquadSemiBoldText fontSize={22} textAlign={'center'} marginTop={35}>
            Success!
          </SquadSemiBoldText>
        ) : (
          <PingFangMediumText fontSize={22} textAlign={'center'} marginTop={35}>
            重新开门成功
          </PingFangMediumText>
        )
      }

      {
        isEnglish ? (
          <SquadRegularText fontSize={16} lineHeight={24} textAlign={'center'} marginTop={15}>
            Cubicles has opened. Please put the food
            <br />
            order inside and close the door.
          </SquadRegularText>
        ) : (
          <PingFangRegularText fontSize={16} lineHeight={24} textAlign={'center'} marginTop={15}>
            柜门已打开。请将食品订单
            <br />
            放入其中并关上柜门。
          </PingFangRegularText>
        )
      }

      {/* 柜子打开的柜门 */}
      {
        curOpenedBoxes.map((box) => (
          <OpenedBox
            key={box.boxNumber}
            width={335}
            boxNumber={box.boxNumber}
            isEnglish={isEnglish}
            cabSizeType={box.cabSizeType}
            lockAddress={box.lockNumber}
            lockPort={box.lockPort}
          />
        ))
      }

      {/* 分隔线 */}
      <DividerLine backgroundColor={'#11202B'} opacity={0.1} marginTop={25} marginBottom={25} width={311} marginLeft={'auto'} marginRight={'auto'} />

      <RowBetween style={{ width: 335, marginLeft: 'auto', marginRight: 'auto', marginTop: 36 }}>
        {/* 重新打开柜门 */}
        <ReopenButton
          onClick={() => reopenBox()}
          isEnglish={isEnglish}
          style={{ width: 162, height: 54, borderRadius: 60, backgroundColor: '#00B595' }}
        />

        {/* 不能使用柜门，弹出反馈窗口，然后重新打开新柜门 */}
        <Button
          onClick={() => setShowProblemModal(true)}
          style={{ width: 169, height: 54, background: '#11202B', borderRadius: 60 }}>
          {
            isEnglish ? (
              <SquadSemiBoldText fontSize={16} color={'#FFFFFF'}>
                Report problems
              </SquadSemiBoldText>
            ) : (
              <div style={{ fontSize: '14px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#11202B', lineHeight: '20px' }}>
                反馈柜子问题
              </div>
            )
          }
        </Button>
      </RowBetween>
    </BackgroundImage>
  );
};

export interface Props {
  cabId32Str: string;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  setShowLoading: (isShow: boolean) => void;
  driverId: number;
  openedBoxes: Box[];
  onClose: () => void;
}

export default ReopenBoxSuccess;
